module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/main-visual-1fbf5ffd2f53708745d0f975f66d22de.jpg";